import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-6 overflow-hidden" data-id="element-24">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="text-left" data-id="element-26">
          <span className="inline-block px-3 py-1 mb-6 text-sm font-medium tracking-wider text-terracotta uppercase bg-terracotta/10 rounded-full" data-id="element-27">
            Protocolo de Emergencia
          </span>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-navy leading-[1.1] mb-6" data-id="element-28">
            Cuando te pega el pico… y tenés que seguir.
          </h1>
          <p className="text-lg md:text-xl text-navy/80 mb-8 leading-relaxed max-w-lg" data-id="element-29">
            5 minutos para bajar la ansiedad (sin apps, sin yoga, sin 'pensar
            positivo'). Un protocolo corto para volver a funcionar.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-30">
            <Button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-31">
              Quiero el Kit 5x5
            </Button>
            <p className="text-sm text-navy/60 mt-3 sm:mt-0 sm:ml-4 flex items-center italic" data-id="element-32">
              *Descarga inmediata en PDF
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-33">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl shadow-navy/10 bg-white p-2" data-id="element-34">
            <img src="https://cdn.magicpatterns.com/uploads/tdzJ9j89icSPSZsgB12bUe/Mockup_2.png" alt="Kit 5 Minutos para Bajar la Ansiedad en tablet" className="w-full h-auto rounded-xl" data-id="element-35" />
          </div>
          {/* Decorative elements */}
          <div className="absolute -top-10 -right-10 w-64 h-64 bg-terracotta/5 rounded-full blur-3xl -z-10" data-id="element-36" />
          <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-sage/20 rounded-full blur-3xl -z-10" data-id="element-37" />
        </motion.div>
      </div>
    </section>;
}